module.exports = __webpack_public_path__ + "assets/0d215e95ea5c9dc3b788c5a3bfce0fdb.png";